window.addEventListener('load', function () {
    if (!window.location.hash) return;

    const target = document.querySelector(window.location.hash);
    if (!target) return;

    const scrollToHash = function () {
        const headerOffset = 120;
        const targetTop = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: targetTop,
            behavior: 'auto'
        });
    };

    requestAnimationFrame(function () {
        scrollToHash();

        setTimeout(scrollToHash, 250);
        setTimeout(scrollToHash, 750);
    });
});